<template>
    <div class="order-page">
        <div class="desc" v-if="showModal == false  && lang == 'fr'">
            <h1>Acheter</h1>
            <p>
            Pour pouvoir commander les gants d’Amélie sur
            internet, vous devez choisir les options suivantes
            pour vos gants.<br />
            Si vous souhaitez commander plusieurs paires de
            teintes, modèles ou tailles différents, il vous suffira de répéter l'opération et ajouter chaque
            paire choisie dans votre panier.
            </p>
            <p>
                <strong>
                    <i class="padlock"></i>
                Notre système de paiement Crédit Mutuel - CIC
                sur internet est parfaitement sécurisé et garanti.
                </strong>
            </p>
            <p>
                Le paiement et la transaction disposent de la
                nouvelle technologie innovante pour vous
                protéger contre l'utilisation frauduleuse de votre
                carte bancaire sur internet <a href="https://www.creditmutuel.fr/fr/particuliers.html" target="_blank">3D-Secure</a>.
            </p>
            <p>
                Pour régler les gants d’Amelie par chèque ou par
                virement bancaire, merci de nous contacter soit :

                <ul>
                    <li>par mail : <a href="mailto:contact@lesgantsdamelie.com">contact@lesgantsdamelie.com</a></li>

                    <li>par téléphone au <a href="tel:+33142880011">0033 (0)1 42 88 00 11</a></li>

                </ul>
                <a class="focus" href="../../static/pdf/web/lesgantsdamelie_bdc.pdf" target="_blank">Cliquez ici pour télécharger et imprimer le bon de commande et les conditions de vente. (PDF)</a>
            </p>

            <p>
                Les gants d’Amélie sont également en vente
                dans le point de vente suivant :
                <address>
                    <a href="http://www.golfdemorfontaine.fr/" target="_blank">Golf de Mortfontaine
                        <br />
                    60128 Mortefontaine - Tel : 03 44 54 68 27</a>
                </address>
            </p>
            <p>
            ( les tarifs pratiqués sont indépendants
            de ceux de notre site )
            </p>
        </div>
        <div class="desc" v-if="showModal == false && lang == 'en'">
            <h1>Buy Amelie's Gloves</h1>
            <p>
                To order Amelie’s gloves on the internet, just
                customize your very own pair by filling out the
                following options.<br />
                If you want to order several pairs of different
                color, pattern or size, simply repeat the process
                and add to cart.
            </p>
            <p>
                <strong>
                    <i class="padlock"></i>
                    Our Credit Mutuel payment system on the Internet is 100% safe and guaranteed.

                </strong>
            </p>
            <p>
                To protect you against the fraudulent use of your
                credit card online, the payment and transaction
                on our website use the most recent
                <a href="https://www.creditmutuel.fr/fr/particuliers.html" target="_blank">3D-Secure
                innovative technology</a>.
            </p>
            <p>
                To place an order and proceed to payment by
                check (in Euro drawn on a bank in France) or
                money order, please contact us either :

            <ul>
                <li>By email, just <a href="mailto:contact@lesgantsdamelie.com">Click here</a></li>

                <li>By phone, dial <a href="tel:+33142880011">0033 (0)1 42 88 00 11</a></li>

                <li>By fax, dial 0033 (0)1 45 25 68 49</li>
            </ul>
            <a class="focus" href="../../static/pdf/web/lesgantsdamelie_bdc.pdf" target="_blank">Click here to download our Order Form and Terms & Conditions. </a>
            </p>

            <p>
                Amelie’s gloves are also available
                at the following retail store:
            <address>
                <a href="http://www.golfdemorfontaine.fr/" target="_blank">Golf de Mortfontaine
                    <br />
                    60128 Mortefontaine - Tel : 03 44 54 68 27</a>
            </address>
            </p>
            <p>
                ( Prices at retail stores are independent of our policy.)
            </p>
        </div>
        <product :lang="lang" @open_modal="this.onOpenColorModal" @close_modal="this.onCloseModal"></product>
    </div>
</template>

<script>
    import Product from './Product';
    import ColorChooser from './ColorChooser';

    export default {
      name: 'Order',
      data() {
        return {
          showModal: false,
        };
      },
      props: ['lang'],
      methods: {
        onOpenColorModal() {
          this.showModal = true;
        },
        onCloseModal() {
          this.showModal = false;
        },
      },
      components: {
        ColorChooser,
        Product,
      },
    };
</script>
<style lang="scss">
    .order-page {
        display: flex;
        animation: fadeIn 1s;

        align-items: stretch;

        @media screen and (max-width:768px){
            flex-direction: column;
        }

        > .order, > .desc {
            flex:45% 0;
            margin: auto;
        }
        strong {color: #9c554b;}

        @media screen and (max-width:768px) {
            > .desc {margin:auto;}
        }
        @media screen and (min-width:768px) {
            > .order {
                margin-top:2rem;
            }
            > .img {
                text-align: right;
                margin-right: 1rem;
                margin-top: 5rem;
            }
        }

        .padlock {
            width:32px;
            height: 32px;
            /*display: inline-block;*/
            float: left;
            margin-right:0.5rem;
            background-image: url('../assets/padlock.png');
            background-size: cover;
        }

        .order{margin-left:2rem;}
    }
</style>



// WEBPACK FOOTER //
// src/components/OrderPage.vue